import { createActions, createReducer } from "reduxsauce";

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setEmbedLoading: [],
    setEmbedFailure: [],
    setEmbedSuccess: [],
    setEmbedConfig: [],
});
 
/**
 * Handlers
 */
const INITIAL_STATE = {
    loading: false,
    errorMessage: null,
    embedConfig: null
};

const setEmbedLoading = (state = INITIAL_STATE ) => {
    return { ...state, loading: true };
}

const setEmbedFailure = (state = INITIAL_STATE, action ) => {
    return { ...state, errorMessage: action.payload, loading: false };
}

const setEmbedSuccess = (state = INITIAL_STATE) => {
    return { ...state, loading: false };
}

const setEmbedConfig = (state = INITIAL_STATE, action) => {
    return {...state, embedConfig: action.payload };
}


/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EMBED_LOADING]: setEmbedLoading,
    [Types.SET_EMBED_FAILURE]: setEmbedFailure,
    [Types.SET_EMBED_SUCCESS]: setEmbedSuccess,
    [Types.SET_EMBED_CONFIG]: setEmbedConfig
});